module.exports = __webpack_public_path__ + "img/date.596408aa.svg";